import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { getKeysBySortedNumberValues } from '../../../../../utils/object/get-sorted-number-values'

function getOrderedMusclesWorkoutUtil (workout) {
  const muscles = (
    getValueReduxUtil(workout, WORKOUT_KEY.MUSCLES) || []
  )
  return getKeysBySortedNumberValues(muscles)
}

export default getOrderedMusclesWorkoutUtil
